import React from 'react';
import { useDispatch } from 'react-redux';
import {
  AppBar,
  Toolbar,
  Box,
  AppBarProps,
  Divider,
  DividerProps,
  Typography,
  FormControlLabel,
  Switch,
  useTheme,
  useMediaQuery,
  Stack,
} from '@mui/material';

import {
  getConfigState,
  toggleAdminEditMode,
} from '../../../store/ConfigSlice';
import { getAuthState } from '../../../store/AuthSlice';
import { USER_PERMISSION } from '../../../store/UserSlice';
import { TP_COLORS } from '../../../constants';
import { useAppSelector } from '../../../hooks';
import { checkUserPermission } from '../../../helper';
import NavigationOptionsIconButton from '../../../components/Headers/NavigationOptionsIconButton';
import HeaderUserProfileOptionsViewer from './HeaderUserProfileOptionsViewer';

interface NavigationBarHeaderProps {
  appBarProps?: AppBarProps;
}

const dividerProps: DividerProps = {
  flexItem: true,
  orientation: 'vertical',
  variant: 'middle',
  sx: { margin: '16px', borderWidth: '1px' },
};

const NavigationBarHeader: React.FC<NavigationBarHeaderProps> = ({
  appBarProps = {},
}) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isXsScreen = useMediaQuery(theme.breakpoints.only('xs'));

  // Store
  const authState = useAppSelector(getAuthState);
  const configState = useAppSelector(getConfigState);

  const authUser = authState.user;

  return (
    <Box flexGrow={1} {...appBarProps}>
      <AppBar
        elevation={0}
        position="fixed"
        color="inherit"
        sx={{
          backgroundColor: TP_COLORS.white,
          boxShadow: '0px 4px 4px 0px #0000000F',
        }}
      >
        <Toolbar>
          <NavigationOptionsIconButton />
          <a href={`${process.env.PUBLIC_URL}/`}>
            <img
              src={`${process.env.PUBLIC_URL}/images/logos/tp-logo-text-green.png`}
              alt="tp-logo"
              style={{ width: '120px' }}
            />
          </a>
          {!isXsScreen && (
            <>
              <Divider {...dividerProps} />

              <Typography variant="h6" color={TP_COLORS.blue.light}>
                Learning Platform
              </Typography>
            </>
          )}
          <span style={{ flexGrow: 1 }} />
          <Stack direction="row" alignItems="center" gap={2}>
            {authUser &&
            checkUserPermission(authUser, {
              adminCourse: USER_PERMISSION.ADMIN_COURSE,
            }) ? (
              <FormControlLabel
                value="start"
                control={
                  <Switch
                    checked={configState.adminEditMode}
                    color="info"
                    onChange={() => dispatch(toggleAdminEditMode())}
                  />
                }
                label="Edit Mode"
                labelPlacement="start"
                sx={{ color: 'info.main' }}
              />
            ) : null}
            <HeaderUserProfileOptionsViewer />
          </Stack>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default NavigationBarHeader;
